<template>
  <div class="bottom-nav__wrapper">
    <nav
      v-if="fastPointsList"
      class="bottom-nav"
    >
      <component
        v-for="(point, i) in fastPointsList"
        :key="`bottom-nav-${i}`"
        :is="point.isDisabled ? 'span' : 'router-link'"
        :class="{ 'menu-point': point.isDisabled }"
        :to="point.isDisabled ? null : routeOf(point)"
        :aria-label="point.anchor"
      >
        <i :class="point.iconName" />
        <span
          v-if="!point.isDisabled && bubbleOf(point)"
          class="bubble"
        >
          {{ bubbleOf(point) }}
        </span>
      </component>
    </nav>
    <nav
      v-else
      class="bottom-nav"
    >
      <router-link :to="{ name: 'program' }">
        <i class="exu-daily-book" />
      </router-link>
      <router-link to="/participants/1">
        <i class="exu-users" />
      </router-link>
      <router-link to="/chat">
        <span
          v-if="newChatUnread"
          class="bubble"
        >
          {{ newChatUnread }}
        </span>
        <i class="exu-mail-2" />
      </router-link>
      <router-link to="/notifications/1">
        <i class="exu-annotation-alert" />
        <span
          v-if="newNotification"
          class="bubble"
        >
          {{ newNotification }}
        </span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import { pointRoute } from '@/components/mixins/menuPoints';

export default {
  name: 'BottomNav',
  props: {
    // Состав панели из fast_apps конфига, уже разобранный и обрезанный до
    // четырёх кнопок (menuPoints.js). null — сервер составом не управляет,
    // тогда кнопки те, что зашиты в разметке ниже.
    fastPointsList: {
      type: Array,
      default: null,
    },
  },
  computed: {
    newNotification() {
      return this.$store.getters.getNewNotificationCount < 10 ? this.$store.getters.getNewNotificationCount : '9+';
    },
    newChatUnread() {
      return this.$store.getters.getUnreadChatCount < 100 ? this.$store.getters.getUnreadChatCount : '9+';
    },
    unApprovedMeeting() {
      return this.$store.getters.getUnApproveMeetingCount < 10 ? this.$store.getters.getUnApproveMeetingCount : '9+';
    },
  },
  methods: {
    // Та же функция, которой menuPoints.js проверяет, что ссылка собирается
    routeOf: pointRoute,
    bubbleOf(point) {
      if (point.moduleName === 'chatView') return this.newChatUnread;
      if (point.moduleName === 'notifications') return this.newNotification;
      if (point.moduleName === 'userCalendar') return this.unApprovedMeeting;
      return null;
    },
  },
};
</script>

<style lang="scss">
.bottom-nav {
  display: flex;
  width: 100%;
  max-width: 760px;
  // height: 60px;
  padding: 10px 10px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  background: #FFFEFB;
  // border-top: 2px solid #F5F5F3;;
  border-radius: 30px;
  box-shadow: 0 0 1px 1px rgba(175, 176, 182, .25);

  @media (min-width: 480px) {
    & {
      width: auto;
      gap: 40px;
    }
  }

  & > a, .menu-point {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 2px solid #2D3038;
    border-radius: 50%;
    text-decoration: none;
    color: #2D3038;
    & > [class^="exu-"], & > [class*=" exu-"] {
      font-size: 20px;
    }

    &.router-link-exact-active, &.router-link-active {
      background: #FCB136;
      border-color: #FCB136;
      & > [class^="exu-"], & > [class*=" exu-"] {
        color: #2D3038;
      }
    }

    .bubble {
      position: absolute;
      bottom: -2px;
      right: -2px;
      display: flex;
      width: 20px;
      height: 20px;
      padding: 3px;
      font-size: .8rem;
      line-height: .8rem;
      background: #FC1010;
      border-radius: 50%;
      color: #FFFEFB;
      align-items: center;
      justify-content: center;
    }
  }
  .menu-point {
    color: #95969D;
    border-color: #95969D;
  }
}
</style>
